const hasKids = (user: any) => {
  if (user?.kids?.length) {
    return true;
  }

  return false;
};

export default hasKids;
